/* HealthyHeads — collectiepagina met tabs
   Wisselt paneel, titel en intro zonder de pagina te herladen. De tab
   komt in de URL te staan, zodat je ernaar kunt linken en de knop
   "terug" blijft werken. */
(function () {
  "use strict";

  function init(root) {
    if (root.dataset.hhColInit === "1") return;
    root.dataset.hhColInit = "1";

    var tabs = Array.prototype.slice.call(root.querySelectorAll("[data-hh-tab]"));
    var panelen = Array.prototype.slice.call(root.querySelectorAll("[data-hh-panel]"));
    var titel = root.querySelector("[data-hh-title]");
    var scroller = root.querySelector("[data-hh-tabs]");
    var intro = root.querySelector("[data-hh-intro]");
    var introTekst = root.querySelector("[data-hh-intro-text]");
    var knop = root.querySelector("[data-hh-readmore]");

    /* ---- intro in- en uitklappen (mobiel) ---- */
    var labelMeer = knop ? knop.textContent.trim() : "";
    var labelMinder = knop ? (knop.dataset.less || "Lees minder") : "";

    function meetIntro() {
      if (!intro || !introTekst || !knop) return;
      if (knop.getAttribute("aria-expanded") === "true") return;
      intro.classList.remove("is-clamped");
      var vol = introTekst.scrollHeight;
      intro.classList.add("is-clamped");
      var kort = introTekst.clientHeight;
      if (vol - kort > 4) {
        knop.hidden = false;
        knop.textContent = labelMeer;
      } else {
        knop.hidden = true;
        intro.classList.remove("is-clamped");
      }
    }

    if (knop) {
      knop.setAttribute("aria-expanded", "false");
      knop.addEventListener("click", function () {
        var open = intro.classList.toggle("is-clamped") === false;
        knop.setAttribute("aria-expanded", open ? "true" : "false");
        knop.textContent = open ? labelMinder : labelMeer;
      });
    }

    /* ---- actieve tab in beeld schuiven ---- */
    function inBeeld(tab, zacht) {
      if (!scroller || scroller.scrollWidth <= scroller.clientWidth) return;
      var doel = tab.offsetLeft - (scroller.clientWidth - tab.offsetWidth) / 2;
      doel = Math.max(0, doel);
      if (zacht && scroller.scrollTo) {
        scroller.scrollTo({ left: doel, behavior: "smooth" });
      } else {
        scroller.scrollLeft = doel;
      }
    }

    /* ---- van tab wisselen ---- */
    function toon(tab, updateUrl) {
      if (!tab) return;

      tabs.forEach(function (t) {
        var actief = t === tab;
        t.classList.toggle("is-active", actief);
        t.setAttribute("aria-selected", actief ? "true" : "false");
      });

      panelen.forEach(function (p) {
        p.hidden = p.id !== tab.dataset.panel;
      });

      if (titel && tab.dataset.heading) titel.textContent = tab.dataset.heading;

      var bron = root.querySelector('[data-hh-store="' + tab.dataset.panel + '"]');
      if (introTekst && bron) introTekst.innerHTML = bron.innerHTML;

      if (knop) {
        knop.setAttribute("aria-expanded", "false");
        knop.textContent = labelMeer;
      }
      meetIntro();
      inBeeld(tab, true);

      if (updateUrl && window.history && window.history.replaceState) {
        window.history.replaceState(null, "", "#" + tab.dataset.slug);
      }
    }

    tabs.forEach(function (t) {
      t.addEventListener("click", function () { toon(t, true); });
      t.addEventListener("keydown", function (e) {
        var i = tabs.indexOf(t);
        var volgende = null;
        if (e.key === "ArrowRight") volgende = tabs[(i + 1) % tabs.length];
        if (e.key === "ArrowLeft") volgende = tabs[(i - 1 + tabs.length) % tabs.length];
        if (volgende) {
          e.preventDefault();
          volgende.focus();
          toon(volgende, true);
        }
      });
    });

    /* ---- openen op de tab uit de URL ---- */
    var hash = (window.location.hash || "").replace("#", "");
    var start = null;
    if (hash) {
      start = tabs.filter(function (t) { return t.dataset.slug === hash; })[0] || null;
    }
    if (start) {
      toon(start, false);
    } else {
      meetIntro();
      var actief = tabs.filter(function (t) { return t.classList.contains("is-active"); })[0];
      if (actief) inBeeld(actief, false);
    }

    var timer;
    window.addEventListener("resize", function () {
      clearTimeout(timer);
      timer = setTimeout(meetIntro, 150);
    });
  }

  function start() {
    document.querySelectorAll("[data-hh-col]").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }

  document.addEventListener("shopify:section:load", function (e) {
    var root = e.target.querySelector("[data-hh-col]");
    if (root) init(root);
  });
})();